module.exports = __webpack_public_path__ + "static/media/login-page-1.f7f3b16e.gif";